// extracted by mini-css-extract-plugin
export default {"notfound":"notfound_notfound__pupFd","notfound-404":"notfound_notfound-404__u0-cW"};